// extracted by mini-css-extract-plugin
export default {"footerlinks":"FooterLinks_footerlinks__AAuha","footerlinks__item":"FooterLinks_footerlinks__item__PbEjp","footerlinks__link":"FooterLinks_footerlinks__link__PdPhu"};